import Swiper, { Autoplay, EffectFade } from "swiper";

const about = () => {
  Swiper.use([Autoplay, EffectFade]);

  const swiper = new Swiper(".about .swiper", {
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    effect: "fade",
    speed: 700,
  });
};

export default about;
